module.exports = __webpack_public_path__ + "img/58.71c8a2f7.png";